import React from 'react'
import { Field, ErrorMessage } from 'formik'
import { Static } from './Static'
import FieldError from './FieldError'
import { Textfield } from 'components/Zui'

const RenderHorizontal = props => {
    return (
        <div className={`input-wrapper-row ${props.static ? 'input-wrapper-row-static' : ''}`}>
            <div className="form-label-row">
                <span>{props.label || props.name}</span>
            </div>

            <div className="input-field-wrapper">{props.children}</div>
        </div>
    )
}

export const Input = props => {
    if (props.horizontal) {
        return (
            <RenderHorizontal {...props}>
                <Field component={!props.static ? InputComponent : Static} {...props} />
                <ErrorMessage name={props.name} component={FieldError} />
            </RenderHorizontal>
        )
    } else
        return (
            <div className="input-wrapper-column">
                {!props.noLabel && (
                    <div className="form-label">
                        <span>{props.label || props.name}</span>
                    </div>
                )}
                <Field component={InputComponent} {...props} />
                <ErrorMessage name={props.name} component={FieldError} />
            </div>
        )
}

const InputComponent = ({ field, form, type, ...props }) => {
    const { onChange, ...fieldProps } = field
    const { error } = form.getFieldMeta(field.name)

    return (
        <Textfield
            {...fieldProps}
            inputType={type}
            onInput={onChange}
            validationCallback={v => {
                return {
                    isValid: !Boolean(error),
                }
            }}
            {...props}
        ></Textfield>
    )
}
